import React from 'react'
import './DesignFooter.css';
import { FaInstagram, FaLinkedin } from 'react-icons/fa6';
import { TiSocialTwitter } from "react-icons/ti";
import { CiFacebook } from "react-icons/ci";
import { RxDoubleArrowUp } from "react-icons/rx";
import { Link } from 'react-router-dom';


const DesignFooter = () => {


    const scrollToTop = () => {
        window.scrollTo({
            top: 0, // Position en pixels depuis le haut de la page
            behavior: 'smooth' // Animation fluide
        });
    };

    return (
        <footer className="container-fluid" style={{ width: "100%", padding: "20px 0px 0px 0px", background: "" }}>
            <div className="container">
                <div style={{ width: "100%", padding: "30px" }} className="row">
                    <div className="col-md-5">
                        <div>
                            <img src="design/images/LOGO_Rezaplus.png" style={{ width: "200px", height: "60px" }} />
                        </div>
                        <div>
                            <p style={{ color: "#A6A6A6" }}>Nous vous proposons une large gamme de véhicules adaptés à tous vos besoins. Que ce soit pour un voyage d{"'"}affaires, des vacances en famille ou une escapade entre amis, nous avons le véhicule parfait pour vous.</p>
                        </div>
                        <div>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <div className="p-2"><FaLinkedin style={{ color: "#43B613" }} size={25} /></div>
                                <div className="p-2"><TiSocialTwitter style={{ color: "#43B613" }} size={25} /></div>
                                <div className="p-2"><CiFacebook style={{ color: "#43B613" }} size={25} /></div>
                                <div className="p-2"><FaInstagram style={{ color: "#43B613" }} size={25} /></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="row pt-5">
                            <div className="col-md-4">
                                <div>
                                    <div><h3 style={{ color: "#737373", fontSize: "20px", textAlign: "center" }}>Savoir plus</h3></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div>
                                    <div><h3 style={{ color: "#737373", fontSize: "20px", textAlign: "center" }}>Services</h3></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div>
                                    <div><h3 style={{ color: "#737373", fontSize: "20px", textAlign: "center" }}>Support</h3></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                    <div className="text-center"><Link to="#" style={{ color: "#A6A6A6" }}>Lien</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", padding: "0px 0px 10px 0px" }}>
                    <div>
                        <div style={{ cursor: "pointer", padding: "10px", borderRadius: "50%", border: "1px #43B613 solid", boxShadow: "0px 0px 2.5px #42B711" }}
                            onClick={scrollToTop}
                        ><RxDoubleArrowUp /></div>
                    </div>
                </div>
            </div>
            {/*<div className="footerBottom" >
            </div> */}
        </footer>
    )
}

export default DesignFooter
